import { format } from 'date-fns';

export default function createDateWithZeroTimeFrom(date: Date): Date {
    const onlyDateString = format(date, 'yyyy-MM-dd');
    return new Date(onlyDateString);
}
